module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-form', {
    attrs: {
      "data": _vm.parent.formFilter,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.filterItems
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc62ef00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/includes/filter.vue
// module id = 1556
// module chunks = 45